export class OnlineCustomer {
	key: string;
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	street1: string;
	street2: string;
	city: string;
	state: string;
	postalCode: string;
	creditCards: OnlineCredit[];
	lastUsed: Date;

	public constructor(init?: Partial<OnlineCustomer>) {
		Object.assign(this, init);
	}
}

export class OnlineCredit {
	type: string;
	token: string;
	displayName: string;
	expirationMonth: string;
	expirationYear: string;
	lastUsed: Date;

	public constructor(init?: Partial<OnlineCredit>) {
		Object.assign(this, init);
	}
}

export enum OnlineCustomerCode {
	ONLINECUSTOMER = "33a2b8407295",
}
